
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/qmee/survey-tips/[surveyTipSlug]",
      function () {
        return require("private-next-pages/qmee/survey-tips/[surveyTipSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/qmee/survey-tips/[surveyTipSlug]"])
      });
    }
  